/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface BvChoiceBlocksInputArgs {
  checked: boolean;
  disabled?: boolean;
  class?: string;
  testName?: string;
  onChange?: (e: MouseEvent) => void;
  onFocus?: (e: FocusEvent) => void;
  onBlur?: (e: FocusEvent) => void;
  onHover?: (e: MouseEvent) => void;
  onMouseEnter?: (e: MouseEvent) => void;
  onMouseLeave?: (e: MouseEvent) => void;
}
export interface BvChoiceBlocksInputSignature {
  Args: BvChoiceBlocksInputArgs;
  Blocks: {
    default: [
      {
        checked: BvChoiceBlocksInputArgs['checked'];
        disabled?: boolean;
        onChange: (e: MouseEvent) => void;
      }
    ];
  };
  Element: HTMLElement;
}

export default class BvChoiceBlocksInputComponent extends Component<BvChoiceBlocksInputSignature> {
  @tracked
  focused: boolean = false;

  @action
  onChange(e: MouseEvent) {
    if (this.args.onChange && !this.args.disabled) {
      this.args.onChange(e);
    }
  }

  @action
  onFocus(e: FocusEvent) {
    this.focused = true;
    if (this.args.onFocus) {
      this.args.onFocus(e);
    }
  }

  @action
  onBlur(e: FocusEvent) {
    this.focused = false;
    if (this.args.onBlur) {
      this.args.onBlur(e);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvChoiceBlocks::Input': typeof BvChoiceBlocksInputComponent;
    'bv-choice-blocks/input': typeof BvChoiceBlocksInputComponent;
  }
}
